export default __webpack_public_path__ + "static/media/fa-regular-400.08f9891a.eot";